import type * as React from 'react';

import { Modal } from '@gitbook/react-uikit';
import { Button } from '@gitbook/spine-react';

/**
 * Modal displayed when user chooses to upgrade their installation to use a Git sync integration.
 */
export function GitSyncLegacyUpgradeModal({
    repository,
    onUpgrade,
    onClose,
}: {
    repository: string;
    onUpgrade: () => void;
    onClose: () => void;
}): React.ReactElement {
    return (
        <Modal
            title="Upgrade Git Sync installation"
            onClose={onClose}
            footer={
                <div className="flex justify-between gap-2">
                    <Button kind="secondary" label="Cancel" onPress={onClose} />
                    <Button kind="primary" label={`Upgrade ${repository}`} onPress={onUpgrade} />
                </div>
            }
        >
            <p className="text-muted">
                Upgrading will require you to authenticate with GitHub or GitLab. Take note of the
                current repository <strong>{repository}</strong> and ensure that you still have
                access to it.
            </p>
        </Modal>
    );
}
